import * as React from 'react';
import type { IListPageLayoutHeaderProps } from './list-page-layout.types';
import { Body2Typography, H4Typography } from '@components/atoms';
import { cn } from '@utils';

export const ListPageLayoutHeader = React.forwardRef<HTMLElement, IListPageLayoutHeaderProps>(
	({ title, subtitle, banner, className, ...props }, ref) => (
		<header
			ref={ref}
			className={cn('flex flex-col gap-2 w-full', className)}
			data-testid="list-page-layout-header"
			{...props}
		>
			{banner}
			<H4Typography className="text-primary">{title}</H4Typography>
			{subtitle && (
				<Body2Typography className="text-primary font-normal" truncate={false}>
					{subtitle}
				</Body2Typography>
			)}
		</header>
	)
);
ListPageLayoutHeader.displayName = 'ListPageLayoutHeader';
